/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Copy_Id_AriaInputs */



/**
* | output |
* | --- |
* | "Copy ID" |
*
* @param {Explorer_Info_Copy_Id_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_copy_id_aria = /** @type {((inputs?: Explorer_Info_Copy_Id_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Copy_Id_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copier l'ID")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kopier-ID")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copia ID")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Копия удостоверения личности")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copiar identificación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("身份证复印件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("IDをコピー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आईडी की प्रतिलिपि बनाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Copiar documento de identidade")
	return /** @type {LocalizedString} */ ("Copy ID")
});